import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addPost({ dispatch, commit }, post) {
    try {
      const { data } = await request.post('posts', post);

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
